import React from "react";
import { Navigate, Outlet } from "react-router-dom";
import secureLocalStorage from "react-secure-storage";
import Sidebar from "../Layouts/Sidebar";

const PrivateComponent = () => {
  const auth = secureLocalStorage.getItem("adminInfo");
  return auth ? (
    <>
      <Sidebar />
      <Outlet />
    </>
  ) : (
    <Navigate to="/" />
  );
};

export default PrivateComponent;
